export const config = {
  title: "Rod Neish Village Realty | Frankfort, IL Real Estate Experts",
  meta: {
    description:
      "Rod Neish Village Realty provides trusted real estate services across Frankfort, IL and surrounding communities. Your local real estate partner for buying, selling, and investment properties.",
    keywords: [
      "Rod Neish",
      "Village Realty",
      "Frankfort IL real estate",
      "homes for sale Frankfort",
      "VRS Realty Frankfort IL",
      "Illinois property listings"
    ],
    author: "Rod Neish Village Realty",
    canonicalUrl: "https://www.neishestates.com/",
  },
  sections: {
    header: {
      businessName: "Rod Neish Village Realty",
    },
    sectionB: {
      heroTitle: "Rod Neish Village Realty",
      heroSubtitle: "Your Trusted Real Estate Experts in Frankfort, IL",
      learnAboutText: "View Listings",
      phoneNumber: "17737588501",
      phoneLabel: "(773) 758-8501",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/2158963873/photo/aerial-view-of-finance-district-in-london.jpg?s=612x612&w=0&k=20&c=nJi-iIIbMROdHkaO8isPR84Y0WPrq0q8ZQ-ck1lGAxQ=",
      cardData: [
        {
          title: "Home Buying",
          description: "Find the perfect home in Frankfort and beyond with our expert guidance.",
        },
        {
          title: "Home Selling",
          description: "Sell your property fast with personalized marketing strategies.",
        },
        {
          title: "Property Investment",
          description: "Explore investment opportunities and maximize your returns.",
        },
      ],
      description:
        "With years of experience and local market expertise, Rod Neish and the Village Realty team are here to make your real estate journey smooth and successful.",
    },
    sectionC: {
      servicesTitle: "Our Real Estate Services",
      servicesDescription:
        "We offer full-service real estate solutions for buyers, sellers, and investors throughout Illinois.",
      cards: [
        {
          title: "Residential Sales",
          description: "Assisting homebuyers and sellers with expert real estate support.",
          imageSrc: "https://media.istockphoto.com/id/2170456340/photo/neighborhood-new-homes-sunset-north-carolina-wide-angle.jpg?s=612x612&w=0&k=20&c=UYZc4IywEHt_dabvvf3DD19mCA_1TdjoSMw58lm1rG4=",
          imageAlt: "Residential Homes",
        },
        {
          title: "Home Valuation",
          description: "Get an accurate and professional assessment of your property’s value.",
          imageSrc: "https://media.istockphoto.com/id/1077145484/photo/close-up-on-employee-woman-finger-hand-holding-statement-report-and-press-on-calculator-for.jpg?s=612x612&w=0&k=20&c=ytmoZibFCiFElBBDZEsbiJJQih45oAdiygxdL2TXS0o=",
          imageAlt: "Home Appraisal",
        },
        {
          title: "Investment Properties",
          description: "Identify, evaluate, and acquire properties that meet your goals.",
          imageSrc: "https://media.istockphoto.com/id/1934343220/photo/real-estate-business-concept-profitable-real-estate-investment-strategies-residential.jpg?s=612x612&w=0&k=20&c=pJuq-sQhHGjfNkQ9UtbGUJd-W6ikGISM71BppAVtqGU=",
          imageAlt: "Real Estate Investments",
        },
      ],
      otherServicesTitle: "Why Choose Rod Neish?",
      otherServicesList: [
        "Local Market Knowledge",
        "Client-First Approach",
        "Proven Track Record",
        "Transparent Process",
        "Trusted VRS Realty Team",
      ],
    },
    sectionD: {
      aboutTitle: "About Rod Neish Village Realty",
      aboutImage: {
        src: "https://images.marketleader.com/MarketingImages/92/2405792_normal.jpg",
        alt: "Rod Neish",
      },
      aboutText: [
        "Rod Neish Village Realty is a part of VRS Realty, serving the Frankfort, IL area and surrounding communities with dedication and integrity.",
        "We work closely with each client to ensure their real estate goals are met efficiently and professionally.",
      ],
    },
    sectionE: {
      profileImage: "https://images.marketleader.com/Logos/96/921896_normal.png",
      profileAlt: "Rod Neish Icon",
      businessName: "Rod Neish Village Realty",
      contact: {
        phone: "17737588501",
        phoneLabel: "(773) 758-8501",
        email: "rodn@VRSRealty.com",
        website: "https://www.neishestates.com/",
        address: "20950 S Frankfort Square Rd, Frankfort, IL 60423, USA",
      },
      socialMedia: {},
    },
    sectionF: {
      address: "20950 S Frankfort Square Rd, Frankfort, IL 60423, USA",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2943.941661758675!2d-87.83062538454161!3d41.499042079252865!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x880e1f79cb46b0c3%3A0x93c2cd4f4067e90d!2s20950%20S%20Frankfort%20Square%20Rd%2C%20Frankfort%2C%20IL%2060423%2C%20USA!5e0!3m2!1sen!2sus!4v1699476462034",
    },
  },
};

export default config;
